export const SERIES_CHATS_CLOSE_AFTER_DAYS = 30
export const CONVERSATION_EDIT_ALLOWED_MINUTES = 60
